import { create } from "zustand";
import { getModelSettings } from "@/apis";
import { assignColorsToModels } from "@/lib/utils";

const initialState = {
  navVisible: localStorage.getItem("navVisible") === "true",
  user: null,
  business: sessionStorage.getItem("business"),
  availableBusinesses: [],
  aiModel: localStorage.getItem("aiModel"),
  availableModels: [],
  isLoadingModels: false,
  showSuggestionPanel: false,
};

const useGlobalStore = create((set, get) => ({
  ...initialState,

  setUser: (user) => set({ user }),
  setBusiness: (business) => set({ business }),
  setNavVisible: (fn) => {
    set((state) => ({ navVisible: fn(state.navVisible) }));
    localStorage.setItem("navVisible", JSON.stringify(get().navVisible));
  },
  setAiModel: (model) => {
    set({ aiModel: model });
    localStorage.setItem("aiModel", model);
  },
  setAvailableBusinesses: (businesses) => set({ availableBusinesses: businesses }),
  toggleSuggestionPanel: () => set((state) => ({ showSuggestionPanel: !state.showSuggestionPanel })),
  hideSuggestionPanel: () => set({ showSuggestionPanel: false }),

  currentModel: () => {
    const { aiModel, availableModels } = get();
    return availableModels.find((model) => model.name === aiModel) || availableModels[0];
  },

  fetchModels: async () => {
    if (get().isLoadingModels) return;

    set({ isLoadingModels: true });

    try {
      const data = await getModelSettings();
      if (Array.isArray(data)) {
        const models = assignColorsToModels(data);
        set({ availableModels: models, isLoadingModels: false });

        const { aiModel } = get();
        if (!models.some((model) => model.name === aiModel) && models.length > 0) {
          const newModel = models[0].name;
          set({ aiModel: newModel });
          localStorage.setItem("aiModel", newModel);
        }
      } else {
        set({ availableModels: [], isLoadingModels: false });
      }
    } catch (error) {
      console.error("Failed to fetch models:", error);
      set({ availableModels: [], isLoadingModels: false });
    }
  },
}));

export default useGlobalStore;
